import React, { useRef, useEffect, useState } from 'react';
import Moment from 'react-moment';
import { AiFillPrinter } from 'react-icons/ai';
import { useReactToPrint } from 'react-to-print';
import ReactToPrint from 'react-to-print';
import LOGO from '../../Assets/plsprint.png'; // adjust path if needed
import { Button, Flexed, Flex, Wrapper, Textauto, MainWrap } from '../../utilities/Shared';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { PLSCSRReps, PLSSalesReps } from '../../utilities/Reps';
import styled from 'styled-components';

const Span = styled.span`
font-size:${props => props.fontSize || "1.6rem"};
font-weight:${props => props.fontWeight || "normal"};

`;

export default function RFQPrintProfessional({
  jobs,
  activeops,
  selectedsalesrep,
  buttonText = "Print RFQ Request",
  buttonStyle = {},
  autoPrint: initialAutoPrint = false, // renamed to avoid confusion
}) {
  const componentRef = useRef();
  const params = useParams();
  const [dataReady, setDataReady] = useState(false);
    const [quoteData, setQuoteData] = useState([]);
const [hasPrinted, setHasPrinted] = useState(false);
const [hidetext, setHideText] = useState(false);
const [customer, setCustomer] = useState({});
const [salesrep, setSalesrep] = useState({});
const [csrrep, setCsrrep] = useState({});
const [location, setLocation] = useState({});
const [contact, setContact] = useState({});
const [components, setComponents] = useState([]);
  // Automatically enable autoPrint if params.id exists
  const autoPrint = !!params?.id || initialAutoPrint;



  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `RFQ_${selectedsalesrep?.label || 'Rep'}_${new Date().toISOString().split('T')[0]}`,
    onBeforePrint: () => {console.log('Preparing RFQ print...')},
    onAfterPrint: () => {console.log('Print dialog closed');setHideText(true)},
  });


    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin':'*' 
      }
    };



useEffect(() => {
  const fetchRFQAndCustomer = async () => {
    // Fetch rep lists early (outside the if — they can be cached/reused)
    const salesReps = await PLSSalesReps().catch(() => []);
    const csrReps   = await PLSCSRReps().catch(() => []);

    if (!autoPrint || !params?.id) {
      setDataReady(true);
      return;
    }

    try {
   

      const payload = { quote: params.id };

      const response = await axios.post(
        "https://highgroundsoftware.com/dash/dashboard/php/getrfqquote",
        payload,
        config
      );

      const quoteData = response.data;

      if (quoteData === null) {
        toast.error(`Quote ${params.id} could not be found.`);
        throw new Error('No Quote Found');
      }

      setQuoteData(quoteData); // no need for await unless it's async setState

      // ── Customer lookup ──
      let customerData = null;
      let salesRep = null;
      let csrRep   = null;
      let mainLocation = null;
   let maincontact = null;
      try {
        const custResponse = await axios.post(
          "http://localhost:5001/customers/getcustomerbyname",
          { name: quoteData?.customer }
        );

        // Assuming your endpoint returns array → take first match
        const customerDoc = custResponse.data?.[0];

        if (customerDoc) {
          customerData = customerDoc;

       

          // Find sales rep (case/type safe)
          salesRep = salesReps.find(
            rep => String(rep._id) === String(customerData.salesrep)
          );

          // Find CSR (same pattern)
          csrRep = csrReps.find(
            rep => String(rep._id) === String(customerData.custrep)
          );

          // Main location (assuming address is array of objects)
          mainLocation = customerDoc.address?.find(
            add => add.itemid === customerData.mainlocation
          );

    setComponents([quoteData?.comp1, quoteData?.comp2, quoteData?.comp3, quoteData?.comp4, quoteData?.comp5, quoteData?.comp6, quoteData?.comp7, quoteData?.comp8, quoteData?.comp9, quoteData?.comp10]);


   // Main contact (assuming contact is array of objects)
          maincontact = customerDoc.contacts?.find(
            add => add.old === quoteData?.contact
          );

        } else {
          console.warn("No customer document in response array");
        }

      } catch (customerErr) {
        console.warn("Failed to load customer info:", customerErr);
        toast.warning("Customer details could not be loaded");
      }
await setCustomer(customerData)
      await setSalesrep(salesRep);
      await setCsrrep(csrRep);
   await setLocation(mainLocation);
     await setContact(maincontact);

      setDataReady(true);

    } catch (error) {
      console.error('Error in data loading chain:', error);
      setDataReady(false);
    }
  };

  fetchRFQAndCustomer();

}, [autoPrint, params?.id]);


useEffect(() => {
  if (autoPrint && params?.id && dataReady && !hasPrinted) {
    const timer = setTimeout(() => {
      if (componentRef.current) {
        console.log('Data ready → opening print dialog (first time only)');
        handlePrint();
        setHasPrinted(true);           // ← this prevents future triggers
      }
    }, 700);

    return () => clearTimeout(timer);
  }
}, [dataReady, autoPrint, params?.id, handlePrint, hasPrinted]);



console.log(quoteData)
  return (
    <>
      {/* Manual print button */}
      <ReactToPrint
        trigger={() => (
          <Button
            bgcolor="#4a90e2"
            color="white"
            padding="8px 20px"
            fontSize="1.2rem"
            border="none"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              ...buttonStyle,
            }}
          >
            <AiFillPrinter size={20} />
            {buttonText}
          </Button>
        )}
        content={() => componentRef.current}
        documentTitle={`RFQ_${selectedsalesrep?.label || 'Rep'}_${new Date().toISOString().split('T')[0]}`}
      />

      {/* Hidden Printable Content */}
    {/* Hidden Printable Content */}
       <div style={{ display: 'none' }}>
         <div ref={componentRef}>
           <Wrapper style={{ background: 'white', padding: '30px 40px' }}>
             {/* Header Section - similar to your packing list */}
             <Flexed margin="0 0 25px 0" style={{ borderBottom: '2px solid #8398AB', paddingBottom: '15px' }}>
               <Flex>
                 <img src={LOGO} alt="PLS Print Logo" style={{ height: '90px' }} />
               </Flex>
               <Flex flex="2" style={{ fontSize: '2.2rem', textAlign: 'center', fontWeight: 'bold' }}>
                 RFQ Summary<br /><span style={{fontSize: '1.6rem',fontWeight:'bold'}}>Project Name:</span><br /> <Span fontSize='1.7rem' fontWeight="bold">{quoteData?.pname}</Span>
               </Flex>
               <Flex style={{ fontSize: '1.4rem', textAlign: 'right' }}>
                 <Moment style={{fontSize: '1.4rem'}} format="MM/DD/YYYY">{new Date()}</Moment><br />
                 at {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}<br />
               
               </Flex>
             </Flexed>

           <Flexed style={{fontSize:'1.7rem',marginTop:'20px'}}>
             <Flex style={{lineHeight:'2.2rem'}}>Request By:
                 <br />{contact?.name}<br />
                 {customer?.name}<br />
                 {location?.address1} {location?.address2}<br />
                 {location?.city}, {location?.state} {location?.zip}
             </Flex>
              <Flex style={{textAlign:'right',lineHeight:'2.2rem'}}><span style={{fontSize:'2.5rem'}}>Quote # {quoteData?.quote}</span><br/><br/><br />Sales Rep: {salesrep?.firstName+' '+salesrep?.lastName?.substr(0,1)}<br />
                       <span style={{fontSize:'1.6rem'}}>CSR</span>: {csrrep?.firstName+' '+csrrep?.lastName?.substr(0,1)}</Flex>
          
           </Flexed>


  <Flexed margin="0 0 25px 0" style={{ borderBottom: '2px solid #8398AB', paddingBottom: '15px' }}></Flexed>




  <Flexed style={{fontSize:'1.6rem',marginTop:'15px',gap:'10px', fontWeight:'bold'}}>
     <Flex>
      Project Style: <Span>{quoteData?.projectstyle}</Span><br />
     Pages:  <Span>{quoteData?.pagecount}</Span><br/>
     Versions:  <Span>{quoteData?.versions}</Span><br />
    
     </Flex>
      <Flex>Cover Style :  <Span>{quoteData?.coverstyle}</Span><br />
      Flat Size:  <Span>{quoteData?.pflatw > "" && <>{quoteData?.pflatw} x {quoteData?.pflatl}</>}</Span><br />
      Finish Size: <Span> {quoteData?.pfoldw > "" && <>{quoteData?.pfoldw} x {quoteData?.pfoldl}</>}</Span><br />
       Press Check:  <Span>{quoteData?.presscheck}</Span>
      <br />
     
      </Flex>
      <Flex flex='1.5'>
        Notes:

        
 {quoteData?.pnotes > "" ? <Textauto border="0" padding="0px 0px 5px 10px" fontSize="1.6rem">{quoteData?.pnotes}</Textauto> : <>No current Notes</>}
       
     
     
    

  </Flex>
 </Flexed>
  <Flexed margin="0 0 25px 0" style={{ borderBottom: '2px solid #8398AB', paddingBottom: '15px' }}></Flexed>

 <Flexed fontSize="1.7rem" padding="10px 0px 5px 0px" backgroundColor='lightgray'>Quantities</Flexed>
  <Flexed fontSize="1.6rem" fontWeight='bold'>
{[...Array(10)].map((_, i) => {
  const values = quoteData?.quantity?.split(',') ?? [];
  const value = values[i]?.trim() ?? '';
  
  return <Flex key={i}>{value}</Flex>;
})}
     
 </Flexed>

 <Flexed border='1px solid black' fontSize="1.6rem" padding='6px 0px'>
     <Flex style={{borderRight:'1px solid black'}}>&nbsp;</Flex>
     <Flex style={{borderRight:'1px solid black'}}>&nbsp;</Flex>
     <Flex style={{borderRight:'1px solid black'}}>&nbsp;</Flex>
     <Flex style={{borderRight:'1px solid black'}}>&nbsp; </Flex>
     <Flex style={{borderRight:'1px solid black'}}>&nbsp; </Flex>
     <Flex style={{borderRight:'1px solid black'}}>&nbsp;  </Flex>
     <Flex style={{borderRight:'1px solid black'}}>&nbsp; </Flex>
     <Flex style={{borderRight:'1px solid black'}}>&nbsp; </Flex>
     <Flex style={{borderRight:'1px solid black'}}>&nbsp; </Flex>
     <Flex ></Flex>
 </Flexed>
      
     <Flexed fontSize="1.7rem" padding="10px 0px 5px 0px" backgroundColor='lightgray' margin='20px 0px 0px 0px'>Component(s) Details</Flexed>


<div style={{border: '1px solid black', marginBottom: '20px' }}>
  {components.filter(comp => !!comp).map((comp, index) => {
      const parts = comp.split(':');
    const frontColorCount = parts[8] ? parts[8].split(',').length : 0;
    const backColorCount = parts[9] ? parts[9].split(',').length : 0; 

  return ( <div key={index} style={{border: '1px solid black', }}>
      {/* Header - always shown for each component */}
      <Flexed bgColor="rgb(0,0,0,.2)" padding="5px" fontSize="1.6rem" fontWeight="bold">
       {parts[0]}{/* Optional: added number so it's clear which one it is */}
      </Flexed>

      {/* Column titles - always shown */}
      <Flexed
        fontSize="1.5rem"
        fontWeight="bold"
        gap="5px"
        borderBottom="1px solid black"
      >
        <Flex>Flat</Flex>
        <Flex>Finished</Flex>
        <Flex flex="3">Paper</Flex>
        <Flex flex=".6">Score</Flex>
        <Flex flex=".6">Perf</Flex>
        <Flex flex=".6">Die</Flex>
        <Flex>Fold</Flex>
        <Flex>Run On</Flex>
      </Flexed>

      {/* Main data row - always shown, uses fallback values when empty */}
      <Flexed fontSize="1.7rem" gap="5px" borderBottom="1px solid black">
        <Flex>{parts[4]+' X '+ parts[5]}</Flex>
        <Flex>{parts[6]+' X '+ parts[7]}</Flex>
        <Flex flex="3">{parts[1]}</Flex>
        <Flex flex=".6">{parts[21]}</Flex>
        <Flex flex=".6">{parts[22]}</Flex>
        <Flex flex=".6">{parts[23]}</Flex>
        <Flex>{parts[24]}</Flex>
        <Flex>{parts[20] || 'Best Press'}</Flex>
      </Flexed>

      {/* Color / Bleed row - always shown */}
  
      <Flexed fontSize="1.7rem" gap="5px">
        <Flex flex='.5'>{frontColorCount}/{backColorCount}</Flex>
        <Flex>Front = {parts[8]}&nbsp;&nbsp;{parts[10] === 'Yes' ? 'With Bleeds' : ''}</Flex>
        
        <Flex /> {/* spacer */}
        <Flex>Back = {parts[9] ? <>{parts[9]}&nbsp;&nbsp;{parts[11] === 'Yes' ? 'With Bleeds' : 'No Bleed'}</> : "No Ink"}</Flex>
       
      </Flexed>
    </div>)
})}
</div>

  <Flexed margin="5px 0" style={{ borderBottom: '2px solid lightgray' }}></Flexed>




 <div style={{border:'1px solid black',marginTop:'30px'}}>
     <Flexed bgColor='rgb(0,0,0,.2)' padding='5px' fontSize="1.6rem" fontWeight='bold'>
         Bindery Details
     </Flexed>
          
            <Flexed fontSize="1.5rem" fontWeight='bold' gap='5px' borderBottom='1px solid black'>
             <Flex>Flat</Flex>
              <Flex>Finished</Flex>
               <Flex >Binding</Flex>
                <Flex>Bind On</Flex>
                 <Flex>Bundle type</Flex>
                  <Flex>Bundle In</Flex>
                   <Flex>Pack Type</Flex>
                    <Flex>Special</Flex>
           </Flexed>
           <Flexed fontSize="1.6rem" gap='5px'  borderBottom='1px solid black'>
             <Flex>{quoteData?.bflatw} x {quoteData?.bflatl}</Flex>
              <Flex>{quoteData?.bfoldw} x {quoteData?.bfoldl}</Flex>
               <Flex >{quoteData?.bindstyle > "" ? quoteData?.bindstyle : ""}</Flex>
                <Flex>{quoteData?.bindon  > "" ? quoteData?.bindon : ""}</Flex>
                 <Flex>{quoteData?.bundletype > "" ? quoteData?.bundletype : ""}</Flex>
                  <Flex>{quoteData?.bundlein > 0 ? quoteData?.bundlein : ""}</Flex>
                   <Flex>{quoteData?.packtype > "" ? quoteData?.packtype : ""}</Flex>
                    <Flex>{quoteData?.special > "" ? quoteData?.special : ""}</Flex>
           </Flexed>
       {quoteData?.binderynotes > "" ? <Textauto>{quoteData?.binderynotes}</Textauto> : null} 
       .     {quoteData?.packagingnotes > "" ? <Textauto>{quoteData?.packagingnotes}</Textauto> : null} 
            
 </div>


 <div style={{border:'1px solid black',marginTop:'30px'}}>
     <Flexed bgColor='rgb(0,0,0,.2)' padding='5px' fontSize="1.6rem" fontWeight='bold'>
         Mailing Details
     </Flexed>
          
            <Flexed fontSize="1.5rem" fontWeight='bold' gap='5px' borderBottom='1px solid black'>
             <Flex flex='2'>Mail Processing by PLS</Flex>
              <Flex>Inserting</Flex>
               <Flex >Tabbing</Flex>
                <Flex>Mail Match</Flex>
                 <Flex>Political</Flex>
               
           </Flexed>
           <Flexed fontSize="1.6rem" gap='5px'  borderBottom='1px solid black'>
             <Flex flex='2' >{quoteData?.mailprocess > 0 ? 'Yes' : 'No'}</Flex>
              <Flex>{quoteData?.inserting > 0 ?  <>{quoteData?.insertnum} insert into a {quoteData?.insertinto}</> : ""}</Flex>
               <Flex >{quoteData?.tabbing > 0 ? quoteData?.tabs+' tabs': ""}</Flex>
                <Flex>{quoteData?.matchmail > 0 ? 'Yes' : ""}</Flex>
                 <Flex>{quoteData?.political > 0 ?'Yes' : ""}</Flex>
                
           </Flexed>
              {quoteData?.mailingnotes > "" ? <Textauto>{quoteData?.mailingnotes}</Textauto> : <>No current Notes</>}

 </div>

 <div style={{border:'1px solid black',marginTop:'30px'}}>
     <Flexed bgColor='rgb(0,0,0,.2)' padding='5px' fontSize="1.6em" fontWeight='bold'>
         Shipping Details
     </Flexed>
          
            <Flexed fontSize="1.6rem" fontWeight='bold' gap='5px' borderBottom='1px solid black'>
             <Flex>  {quoteData?.shippingnotes > "" ? <Textauto>{quoteData?.shippingnotes}</Textauto> : <>No current Notes</>}</Flex>
           </Flexed>
           <Flexed fontSize="1.6rem" gap='5px'  borderBottom='1px solid black'>
             <Flex></Flex>
            </Flexed>
             
 </div>

             {/* Table Rows
             {jobs?.map((jobinfo, index) => {
               const matchingOp = activeops.find(op => String(op.job) === String(jobinfo.job));
               const opName = matchingOp ? matchingOp.name : 'On Incoming';

               return (
                 <Flexed
                   key={jobinfo._id || index}
                   padding="10px 8px"
                   style={{
                     borderBottom: '1px solid #ddd',
                     backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white',
                     fontSize: '1.05rem'
                   }}
                 >
                   <Flex>{jobinfo?.job || '—'}</Flex>
                   <Flex flex="2">{jobinfo?.customer || '—'}</Flex>
                   <Flex flex="2">
                     {jobinfo?.quantity 
                       ? new Intl.NumberFormat('en-US').format(Number(jobinfo.quantity)) 
                       : '—'}
                   </Flex>
                   <Flex>
                     {jobinfo?.dateentered 
                       ? <Moment format="MM/DD/YYYY">{jobinfo.dateentered}</Moment> 
                       : '—'}
                   </Flex>
                   <Flex>
                     {jobinfo?.duedate 
                       ? <Moment format="MM/DD/YYYY">{jobinfo.duedate}</Moment> 
                       : '—'}
                   </Flex>
                   <Flex>{jobinfo?.custpo || '—'}</Flex>
                   <Flex>{opName}</Flex>
                 </Flexed>
               );
             })} */}

             {/* Footer */}
             <Flexed margin="40px 0 0 0" style={{ fontSize: '1rem', color: '#555' }}>
               <Flex>Printed by: {sessionStorage.getItem('fullName') || '—'}</Flex>
               <Flex textAlign="right">
              
               </Flex>
             </Flexed>
           </Wrapper>
         </div>
       </div>
      {!hidetext && <MainWrap style={{fontSize:'2rem',display:'flex',justifyContent:'center'}}>Preparing RFQ Summary...</MainWrap>} 
    </>
  );
}